import { render, staticRenderFns } from "./view-files-labtests.vue?vue&type=template&id=e3fdedac"
import script from "./view-files-labtests.vue?vue&type=script&lang=js"
export * from "./view-files-labtests.vue?vue&type=script&lang=js"
import style0 from "./view-files-labtests.vue?vue&type=style&index=0&id=e3fdedac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports